import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class CheckAvatarGuard implements CanActivate, CanActivateChild {
    constructor(public auth: AuthService, public router: Router) {
      // console.warn('CheckAvatarGuard guard');
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        // console.log('check-avatar guard called');
        const avatarSet = this.auth.getAvatar();
        if (!avatarSet) {
          // console.log('redirect to create avatar')
            this.router.navigate(['createAvatar']);
            return false;
        }
        // console.log('avatar is available')
        return true;
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        return this.canActivate(childRoute, state);
    }
}
